var exports = {
  "L": "overlay__RjK0wp",
};

module.exports = exports;
